import React, { useRef, useEffect } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';

const Model = () => {
  const group = useRef();
  const { scene, animations } = useGLTF('/planet/scene.gltf');
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    if (actions && animations.length > 0) {
      actions[animations[0].name].play(); // Play the first animation
    }
  }, [actions, animations]);

  return <primitive ref={group} object={scene} scale={0.3} position={[0, 0, 0]}     // X (left-right), Y (up-down), Z (forward-back)
  rotation={[0.3, 1, 0.2]} />;
};

export default Model;
